'use client';

import { useEffect } from 'react';
import { trackLoginCompleted } from '@/app/lib/analytics-events';

// Returning users who sign in with Google never touch the /auth/login page — the OAuth callback
// (a server route, so it can't fire client analytics) redirects them straight to their destination
// with a transient `?auth_event=login_completed` marker. This runs on the fresh page load that
// redirect produces, fires the event, then strips the marker from the URL without a navigation.
export function AuthEventTracker() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const authEvent = params.get('auth_event');
    if (!authEvent) return;

    if (authEvent === 'login_completed') {
      trackLoginCompleted('google');
    }

    params.delete('auth_event');
    const search = params.toString();
    const url = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
    window.history.replaceState(null, '', url);
  }, []);

  return null;
}
